import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TimeService } from '@bayclubs/utils';
import { camps } from '../../../models/models.generated';
import { CampCareBookingApiService } from '../../../services/api/camp-care-booking-api.service';
import { CampCareBookingsCalendarEventService } from './camp-care-bookings-calendar-event.service';




@Component({
    selector: 'app-camp-care-booking-calendar',
    templateUrl: './camp-care-booking-calendar.component.html',
    styleUrls: ['./camp-care-booking-calendar.component.scss'],
    standalone: false
})
export class CampCareBookingCalendarComponent implements OnInit, OnDestroy {

    @Input()
    public searchForm: UntypedFormGroup;

    public isBusy = false;

    public calendarData: camps.CampCareBookingCalendarData;

    private refreshCalendarSubscription = null;

    constructor(private bookingApi: CampCareBookingApiService
        , private eventService: CampCareBookingsCalendarEventService
    , private time: TimeService) { }

    ngOnInit() {
        // this.searchForm.valueChanges
        //     .debounceTime(500)
        //     .subscribe((value) => {
        //         this.search();
        //     });

        this.refreshCalendarSubscription = this.eventService.refreshCalendar$.subscribe(()=>{
            this.search();
        });
    }

    ngOnDestroy(){
        if(this.refreshCalendarSubscription){
            this.refreshCalendarSubscription.unsubscribe();
            this.refreshCalendarSubscription = null;
        }
    }

    private search(): void {

        this.isBusy = true;

        let request = <camps.CampCareBookingCalendarRequest>{
            campId: this.searchForm.controls['campId'].value,
            clubId: this.searchForm.controls['clubId'].value,
            dateFrom: this.time.toBcDate(this.searchForm.controls['dateFrom'].value),
            dateTo: this.time.toBcDate(this.searchForm.controls['dateTo'].value),
            ages: this.calendarData != null ? this.calendarData.ages : null
        }

        this.bookingApi.getCalendarData(request).subscribe(response => {
            this.isBusy = false;
            this.calendarData = response.value;
        }, () => { this.isBusy = false; });
    }

}
